module.exports = __webpack_public_path__ + "img/strike.4bb903b3.svg";